<!-- @format -->

<template>
  <div>
    <div v-if="!isTreeView" class="list-view">
      <div class="tree-level d-flex flex-wrap align-items-center">
        <div
          v-for="(item, index) in treeLevel"
          :key="index"
          class="tree-level-item"
          :style="{ background: item.color }"
        >
          {{ item.name }}
        </div>
      </div>
      <div v-if="!listReady" class="list-loading text-center py-3">
        <b-spinner small type="grow" />
        <span class="ml-50">Loading...</span>
      </div>
      <vue-ads-table
        v-else
        :columns="columns"
        :rows="tableRows"
        :page="page"
        :filter="tableFilter"
        @page-change="pageChanged"
        @filter-change="onFilterChange"
      >
        <template slot="toggle-children-icon" slot-scope="props">
          <div v-if="props.expanded">
            <feather-icon size="24" icon="MinusIcon" style="box-shadow: 0 0 10px #ccc" />
          </div>
          <div v-else>
            <feather-icon size="24" icon="PlusIcon" />
          </div>
        </template>
        <template slot="id" slot-scope="props">
          <div :style="{ color: props.row._children && props.row._children.length ? 'green' : '#000' }">
            {{ props.row.id }}
            <b-avatar
              v-if="resolveAvatarSrc(props.row.avatar)"
              button
              :src="resolveAvatarSrc(props.row.avatar)"
              class="ml-50"
            />
          </div>
        </template>
        <template slot="level" slot-scope="props">
          {{ props.row.level_name }}
        </template>
      </vue-ads-table>
    </div>

    <div v-else class="tree">
      <div class="tree-level d-flex">
        <div class="tree-level-item" v-for="(item, index) in treeLevel" :key="index" :style="{ background: item.color }">
          {{ item.name }}
        </div>
        <b-form-input v-model="member" class="d-inline-block mr-1" placeholder="Member ID" @input="changeSome" />
        <b-form-input v-model="memberNAME" class="d-inline-block mr-1" placeholder="Member NAME" @input="changeSome2" />
        <button @click="findNext">Find Next</button>
      </div>
      <b-button @click="zoomIn" style="z-index: 99; position: relative; margin: 10px">Zoom in</b-button>
      <b-button @click="zoomOut" style="z-index: 99; position: relative; margin: 10px">Zoom out</b-button>
      <b-button @click="centerScale" style="z-index: 99; position: relative; margin: 10px">Reset</b-button>
      <TreeChart
        v-if="treeData.id"
        :dataset="treeData"
        :config="treeConfig"
        ref="tree"
        class="tree-content"
        :link-style="'straight'"
      >
        <template v-slot:node="{ node, collapsed }">
          <div
            class="rich-media-node"
            :node-id="node.id"
            :node-name="node.real_name"
            :style="{ background: node.color || '#ffffff', border: collapsed ? '2px solid grey' : '' }"
          >
            <b-avatar
              ref="previewEl"
              :src="node.avatar"
              :text="avatarText(node.real_name)"
              size="48px"
              rounded
            />
            <p class="rich-media-name">
              <span>{{ node.real_name }}</span>
              <span>{{ node.id }}</span>
              <span style="text-align: center; margin-left: -57px">{{ node.hasChild ? '+' : '' }}</span>
            </p>
          </div>
        </template>
      </TreeChart>
    </div>
  </div>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'
import axiosIns from '@/libs/axios'
import { BAvatar, BButton, BFormInput, BSpinner } from 'bootstrap-vue'
import TreeChart from '@ssthouse/vue-tree-chart'
import VueAdsTable from 'vue-ads-table-tree'
import 'vue-ads-table-tree/dist/vue-ads-table-tree.css'
import { avatarText } from '@core/utils/filter'

const getTransform = transform => {
  const arr = transform.split(') ')
  const obj = {}
  arr.forEach(item => {
    const o = item.split('(')
    const v = o[1]
    obj[o[0]] = v.slice(0, v.length - 1)
  })
  const translateArr = obj.translate ? obj.translate.split(' ') : []
  const left = translateArr[0] || 0
  return {
    top: translateArr[1] || 0,
    left: left === 0 ? 0 : left.slice(0, left.length - 1),
    scale: obj.scale || 1
  }
}

export default {
  components: {
    TreeChart,
    BButton,
    BAvatar,
    BFormInput,
    BSpinner,
    VueAdsTable,
  },
  data() {
    return {
      searchResults: [],
      searchIndex: -1,
      member: '',
      memberNAME: '',
      treeData: {},
      tableRows: [],
      tableFilter: '',
      listReady: false,
      page: 0,
      columns: [
        {
          title: 'Selection',
          collapseIcon: true,
        },
        {
          property: 'real_name',
          title: 'Agent Name',
          filterable: true,
        },
        {
          property: 'level_name',
          title: 'Agent Level',
          filterable: true,
        },
        {
          property: 'id',
          title: 'Agent ID',
          filterable: true,
        },
      ],
      tree: [],
      treeLevel: [],
      colorArray: ['#e6e2e3', '#f5eb56', '#b6cca5', '#86b6da', '#cb7a77', '#595c87', '#cd8d51', '#0f9289'],
      lock: false,
      scal: 1,
      treeConfig: { nodeWidth: 220, nodeHeight: 80, levelHeight: 200 },
      treeInitialized: false,
      basePosition: { top: 0, left: 0 },
      currentIndex: -1,
    }
  },
  computed: {
    isTreeView() {
      return this.$route.query.view === 'tree'
    },
  },
  watch: {
    isTreeView(val) {
      if (val) {
        this.$nextTick(() => {
          this.initTreeInteractions()
          this.captureBasePosition()
        })
      }
    },
  },
  created() {
    this.shuju()
  },
  beforeDestroy() {
    document.onmousemove = null
    document.onmouseup = null
    this.treeLevel = []
  },
  methods: {
    avatarText,
    resolveAvatarSrc(avatar) {
      if (!avatar) return ''
      if (avatar.includes('http') || avatar.includes('api')) {
        return avatar
      }
      return `https://api.myonewow.com/${String(avatar).replace(/^\//, '')}`
    },
    pageChanged(page) {
      this.page = page
    },
    onFilterChange(filter) {
      this.tableFilter = filter
      this.page = 0
    },
    convertToTableRows(list) {
      if (!list || !list.length) return []
      return list.map(item => {
        const row = {
          id: item.id,
          real_name: item.real_name,
          avatar: item.avatar,
          level: item.level,
          level_name: item.level ? item.level.name : '',
        }
        if (item.child && item.child.length) {
          row._children = this.convertToTableRows(item.child)
          row._showChildren = false
        }
        return row
      })
    },
    buildTableRows(rootNode, children) {
      if (!rootNode || !rootNode.id) {
        this.tableRows = this.convertToTableRows(children)
        return
      }
      this.tableRows = [{
        id: rootNode.id,
        real_name: rootNode.real_name,
        avatar: rootNode.avatar,
        level: rootNode.level,
        level_name: rootNode.level ? rootNode.level.name : '',
        _children: this.convertToTableRows(children),
        _showChildren: false,
      }]
    },
    initTreeInteractions() {
      if (this.treeInitialized) return
      const box = document.getElementsByClassName('tree-content')[0]
      if (!box) return

      const _this = this

      function addEvent(obj, xEvent, fn) {
        if (obj.attachEvent) {
          obj.attachEvent(`on${xEvent}`, fn)
        } else {
          obj.addEventListener(xEvent, fn, false)
        }
      }

      function onMouseWheel(e) {
        _this.lock = true
        const ev = e || window.event
        let down = true
        down = ev.wheelDelta ? ev.wheelDelta < 0 : ev.detail > 0
        if (down) {
          _this.scal = (parseFloat(_this.scal) + 0.01).toFixed(2)
        } else {
          if (_this.scal == 0.01) {
            _this.scal = 0.01
            return
          }
          _this.scal = (parseFloat(_this.scal) - 0.01).toFixed(2)
        }
        _this.updateScale(_this.scal)

        if (ev.preventDefault) {
          ev.preventDefault()
        }
        return false
      }

      let x1 = 0
      let y1 = 0

      function onMousemove(e) {
        const ev = e || window.event
        const x2 = ev.clientX
        const y2 = ev.clientY
        const x = x2 - x1
        const y = y2 - y1
        const tree = document.getElementsByClassName('vue-tree')[0]
        if (!tree) return
        const leftTop = getTransform(tree.style.transform)
        const left = `${parseFloat(leftTop.left) + parseFloat(x)}px`
        const top = `${parseFloat(y) + parseFloat(leftTop.top)}px`
        _this.moveTree(left, top)

        if (ev.preventDefault) {
          ev.preventDefault()
        }
      }

      function onMouseup() {
        box.removeEventListener('mousemove', onMousemove)
      }

      function onMousedown(e) {
        x1 = e.clientX || e.clientx || 0
        y1 = e.clientY || e.clienty || 0
        addEvent(box, 'mousemove', onMousemove)
        addEvent(box, 'mouseup', onMouseup)
      }

      addEvent(box, 'mousewheel', onMouseWheel)
      addEvent(box, 'DOMMouseScroll', onMouseWheel)
      addEvent(box, 'mousedown', onMousedown)
      this.treeInitialized = true
    },
    captureBasePosition() {
      if (!this.$refs.tree || !this.$refs.tree.$el) return
      const treeContent = this.$refs.tree.$el
      if (!treeContent.children[0]) return
      const { transform } = treeContent.children[0].style
      const leftTop = getTransform(transform)
      this.basePosition = {
        top: leftTop.top,
        left: leftTop.left,
      }
    },
    changeSome(val) {
      if (!val || !this.basePosition) return
      const dom = document.querySelector(`div[node-id='${val}']`) || document.querySelector(`div[node-id*='${val}']`)
      if (!dom || !dom.parentNode) return
      const { left, top } = dom.parentNode.style
      const newLeft = `${parseFloat(this.basePosition.left) - parseFloat(left)}px`
      const newTop = `-${parseFloat(top) + parseFloat(this.basePosition.top)}px`
      this.moveTree(newLeft, newTop)
    },
    changeSome2(val) {
      if (!val) {
        this.searchResults = []
        this.currentIndex = -1
        return
      }
      const nodes = document.querySelectorAll(`div[node-name*='${val}']`)
      this.searchResults = Array.from(nodes)
      this.currentIndex = -1
    },
    findNext() {
      if (this.searchResults.length === 0) return
      this.currentIndex = (this.currentIndex + 1) % this.searchResults.length
      const dom = this.searchResults[this.currentIndex]
      const { left, top } = dom.parentNode.style
      const newLeft = `${parseFloat(this.basePosition.left) - parseFloat(left)}px`
      const newTop = `-${parseFloat(top) + parseFloat(this.basePosition.top)}px`
      this.moveTree(newLeft, newTop)
    },
    collapseTreeNode(node) {
      if (!node || !node.children || !node.children.length) return
      node.children.forEach(child => this.collapseTreeNode(child))
      node._children = node.children
      node.children = null
      node._collapsed = true
    },
    getTreeChildren(data) {
      if (!data || data.length === 0) return []
      data.forEach(item => {
        item.children = item.child
        const level_id = item.level.id - 1
        item.color = this.treeLevel[level_id] ? this.treeLevel[level_id].color : '#ffffff'
        if (item.child && item.child.length) {
          item.hasChild = true
          this.getTreeChildren(item.child)
        }
      })
      return data
    },
    async shuju() {
      this.listReady = false
      try {
        const [levelResponse, userInfo, treeResponse] = await Promise.all([
          axiosIns.get('/user/userLevelList'),
          axiosIns.get('order/create-user'),
          useJwt.offlineTree(),
        ])

        this.treeLevel = levelResponse.data || []
        this.treeLevel.forEach((item, index) => {
          item.color = this.colorArray[index]
        })

        const rawChildren = [...(treeResponse?.data?.list || [])]
        const children = this.getTreeChildren(rawChildren)
        const storedUser = JSON.parse(localStorage.getItem('userData') || '{}')
        this.treeData = {
          ...storedUser,
          ...userInfo.data,
          hasChild: children.length > 0,
          children,
        }
        this.collapseTreeNode(this.treeData)
        const level_id = this.treeData.level_id - 1
        if (this.treeLevel[level_id]) {
          this.treeData.color = this.treeLevel[level_id].color
        }
        this.buildTableRows(this.treeData, rawChildren)

        if (this.isTreeView) {
          this.$nextTick(() => {
            this.initTreeInteractions()
            this.captureBasePosition()
          })
        }
      } finally {
        this.listReady = true
      }
    },
    moveTree(left, top) {
      const tree = document.getElementsByClassName('vue-tree')[0]
      const content = document.getElementsByClassName('dom-container')[0]
      if (!tree || !content) return
      const str = `scale(${this.scal}) translate(${left}, ${top})`
      tree.style.transform = str
      content.style.transform = str
    },
    updateScale(scale) {
      const tree = document.getElementsByClassName('vue-tree')[0]
      const content = document.getElementsByClassName('dom-container')[0]
      if (!tree || !content) return
      const getTransformData = getTransform(tree.style.transform)
      this.scal = scale || getTransformData.scale
      const str = `scale(${scale}) translate(${getTransformData.left}, ${getTransformData.top})`
      tree.style.transform = str
      content.style.transform = str
    },
    centerScale() {
      if (this.$refs.tree) {
        this.$refs.tree.restoreScale()
      }
      this.updateScale(1)
    },
    zoomIn() {
      this.updateScale(parseFloat(this.scal) + 0.17)
    },
    zoomOut() {
      let scale = parseFloat(this.scal)
      if (scale - 0.17 < 0) {
        scale = 0.001
      } else {
        scale -= 0.17
      }
      this.updateScale(scale)
    },
  },
}
</script>

<style lang="scss" scoped>
.list-view {
  .tree-level {
    margin: 10px 10px 0;
  }

  .list-loading {
    min-height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.tree {
  background: rgb(105, 105, 105);
  overflow: hidden;
  min-height: calc(100vh - 110px);
  position: relative;

  .tree-content {
    position: absolute;
    top: 80px;
    left: 0;
    width: 100%;
    max-height: 80vh;
    height: 80vh;
    .node-slot {
      width: 220px;
    }
  }
}
.tree-level {
  margin: 10px 10px;
  div.tree-level-item {
    width: 80px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    margin-right: 10px;
    color: #000;
    position: relative;
    border-radius: 10px;
    z-index: 99;
    div.pos {
      position: absolute;
      top: 0;
      right: 0;
      height: 10px;
      width: 20px;
    }
  }
}
.rich-media-node {
  display: flex;
  padding: 4px 4px 2px;
  border-radius: 3px;
}
.rich-media-name {
  margin: 0 0 0 10px;
  font-weight: bold;
  color:#ffffff;
  font-size: 1.5rem;
  display: flex;
  flex-direction: column;
  span {
    margin-bottom: 4px;
    color: #000000;
  }
}
</style>
